import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import CurrentLocations from "./CurrentLocations";
import VehicleHistory from "./VehicleHistory";
import CurrentLocation from "./CurrentLocation";
import LiveTripsBoard from "./LiveTripsBoard";

export const MapsRouter: FC<{}> = () => {
  return (
    <Routes>
      <Route path="/history" element={<VehicleHistory />} />
      <Route path="/live-trips" element={<LiveTripsBoard />} />
      <Route path="/current-location" element={<CurrentLocation />} />
      <Route index element={ <CurrentLocations />} />
    </Routes>
  );
};
